/**
 * @Author: ZhouQiang
 * @Date: 2023-03-22 10:05:10
 * @LastEditors: ZhouQiang
 * @LastEditTime: 2023-04-04 14:51:38
 * @description: description
**/
export default {
  data() {
    return {
      uploadConfig: null,
      uploadKey: '',
      imageUrl: '',//未截取前的图片
      cropperVisible: false, // 裁剪弹窗显示隐藏
      fileName: '', /**文件名称 */
      uploadIndex:0,
      uploadFile:null,//图片截取后的文件
      loading: false
    }
  },
  methods: {
    /**上传图片错误 */
    handleFormatError() {
      this.$Message.error('请上传图片类型文件，支持jpg;jpeg;png;bmp格式')
    },
    /**上传图片进度 */
    imageProgress(res, file) {
      if (!file) {
          return
      }
      this.loading = true
    },

    //base64转file
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },

    /**图片上传前钩子 */
    handleUploadIntercept (file,i = 0) {
      if (file.type.indexOf('image') <= -1) {
        return
      }
      this.uploadIndex = i;
      this.fileName = file .name
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
          this.imageUrl = reader.result
          this.cropperVisible = true
          if (this.handleCroper) this.handleCroper()
      }
      return false
    },

    /**刷新上传配置
     * key: 上传字段，便于获取当前操作字段
    */
    refreshUploadToken(key = '') {
      this.uploadKey = key
      this.loadUploadToken((token) => {
          this.uploadConfig = {
              token: token
          }
      })
  },

    async uploadRichTextImage(html) {
      if(!html) return ''
      const list = []
      const base64Regex = /src="data:image\/(png|jpg|jpeg|gif);base64,([^"]+)"/gi;
      html.replace(base64Regex, (match) => {
        list.push(match.slice(5,-1))
        return match
      });
      const token = await new Promise(resolve => {
        this.loadUploadToken((res)=>{
          resolve(res)
        })
      })
      const newList = await Promise.all(list.map((v)=> this.uploadBase64Image(v,token)))
      const newHtmlString = html.replace(base64Regex, (match) => {
        const index = list.indexOf(match.slice(5,-1))
        return newList[index] ? `src="${newList[index]}"` : match
      })
      return newHtmlString
    },

    async uploadBase64Image(base64Url,token){
      const file = this.dataURLtoFile(base64Url,  Math.random().toString(32).slice(2) + '.png')
      const res = await this.$api.uploadFile(file, token)
      if(res.data.key){
        return '//igyl.weizhilian.com/' + res.data.key
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/upload.js